// src/components/LoginModal.jsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'axios';
import { xorEncrypt } from '../utils/xorCrypto';
import { useTokens } from '../context/TokenContext';
import { APP_URL, MAIN_URL } from '../constants';

const LoginModal = ({ show, userType = 'admin', loginPath, onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { setItem } = useTokens();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(loginPath, {
        email,
        password: xorEncrypt(password),
      });

      const { status, token, user } = response.data;

      if (status === 'success' && token) {
        setItem(userType, 'AuthToken', token);
        setItem(userType, 'UserInfo', user || {});

        toast.success('Login successful!');
        onLogin(token, user || {});
      } else {
        throw new Error(response.data.message || 'Invalid credentials');
      }
    } catch (error) {
      const msg = error?.response?.data?.message || error.message || 'Login failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>{`${userType.charAt(0).toUpperCase() + userType.slice(1)} Login`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button type="submit" className="w-100" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </Form>
        <div className='mt-3'>
          <a href={MAIN_URL}><i className='bi bi-arrow-left'></i> Go back to the site</a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
